import { Sheet, SheetContent, SheetDescription, SheetTitle } from "@/components/ui/sheet";
import { gross, isPro, lei, resale, shortName } from "@/lib/pricing";
import { waLink } from "@/lib/wa";
import { WhatsAppGlyph } from "@/components/cards/CardShell";

export default function ProductSheet({ p, data, onClose, track }) {
  const pro = p && isPro(data, p.id);
  const wa = p && waLink(data.contact.whatsapp, `Bună ziua, aș dori să comand: ${shortName(p.name)} ${p.size} (cod ${p.code}) · ${lei(gross(p.price, data.vat))} (TVA inclus)`);
  return (
    <Sheet open={!!p} onOpenChange={(o) => !o && onClose()}>
      <SheetContent side="bottom" className="ps-sheet" data-testid="product-sheet">
        {p && (
          <>
            <div className="ps-img">{p.image && <img src={p.image} alt={p.name} />}</div>
            <span className="pub-eyebrow">{p.category} · cod {p.code}</span>
            <SheetTitle className="ps-title" data-testid="product-sheet-name">{shortName(p.name)} <span>{p.size}</span></SheetTitle>
            <SheetDescription className="ps-desc">
              {pro
                ? `Format profesional pentru tratamente în salon: un set complet = minim ${data.treatments} tratamente.`
                : `Produs de revânzare la raft, cu adaos recomandat de ${data.markup}%.`}
            </SheetDescription>
            <div className="ps-prices">
              <div><small>Preț salon</small><b data-testid="product-sheet-price">{lei(gross(p.price, data.vat))}</b><span>TVA inclus</span></div>
              {pro ? (
                <div><small>Tratamente / set</small><b>{data.treatments}</b><span>× min. {lei(data.service_price)}</span></div>
              ) : (
                <div className="is-resale"><small>Revânzare</small><b data-testid="product-sheet-resale">{lei(resale(p.price, data.markup, data.vat))}</b><span>profit {lei(gross(p.price, data.vat) * data.markup / 100)}/buc</span></div>
              )}
            </div>
            {wa && (
              <a className="st-btn pub-wa ps-order" href={wa} target="_blank" rel="noopener noreferrer" onClick={() => track?.("order", "sheet", [{ id: p.id, qty: 1 }])} data-testid="product-sheet-order-btn">
                <WhatsAppGlyph /> Comandă pe WhatsApp
              </a>
            )}
          </>
        )}
      </SheetContent>
    </Sheet>
  );
}
